import NotificationToast from '@/common/components/NotificationToast'
import { useNotificationsRecipientMessages } from '@/common/hooks/useNotificationsRecipientMessages'
import { useNotificationStore } from '@/common/stores/useNotificationStore'
import { NotificationData } from '@/common/types/notifications'
import { useEffect } from 'react'
import { toast } from 'react-toastify'

export const useNotification = () => {
  const { lastDisplayIdentifier, setNotSeenCount, incrementRefreshTick } = useNotificationStore()

  const { data: notificationsData, meta } = useNotificationsRecipientMessages<NotificationData[]>({
    params: {
      sendDisplayIdentifier: true,
      pageSize: 100,
      refetchInterval: 1000 * 30,
    },
  })

  useEffect(() => {
    incrementRefreshTick()
    setNotSeenCount(meta?.not_seen_count ?? 0)

    if (!notificationsData?.[0]?.id) {
      return
    }

    const newNotifications = notificationsData?.filter(
      ({ display_identifier, seen_at }) => display_identifier === lastDisplayIdentifier && !seen_at,
    )

    const isTestEnv = process.env.NODE_ENV === 'test'

    if (!newNotifications?.length || isTestEnv) {
      return
    }

    newNotifications.slice(0, 5).forEach((notification) => {
      toast(<NotificationToast />, {
        data: {
          title: notification.content.title,
          date: new Date(notification.created_at),
          body: notification.content.body,
          icon: notification.content.icon,
          iconColor: notification.content.icon_color,
        },
      })
    })
  }, [notificationsData?.[0]?.id, meta?.not_seen_count])
}
